import AddressFormVM from '@/view-model/AddressFormVM';
const createHubManagementFormData = () => ({
    masterId: '',
    masterPassword: '',
    name: '',
    addressFormData: new AddressFormVM({}),
    hubRepresentativePhone: '',
    phone: '',
    fax: '',
    workingTime: {
        on: '00:00',
        off: '23:59',
    },
    withdrawalBankCode: null,
    withdrawalBankAccount: '',
    withdrawalBankOwner: '',
    // 서버 사업자 검증 로직을 통과하려면 실제 사업자등록번호가 입력되어야 함, ex) 1138521083
    businessNumber: '',
    businessName: '',
    ceoName: '',
    ceoPhone: '',
    ceoEmail: '',
    businessCondition: '',
    businessType: '',
    hubConfiguration: {
        // formDTO에서 string type으로 변환 필요, Y | N
        assignedWorkerCatchYn: false,
        sortByCode: 'USER_CHOICE',
        // formDTO에서 string type으로 변환 필요, Y | N
        kilometerProductAllYn: false,
        minimumKilometerProduct: 1,
        kilometerProduct: 10,
        shareCallColorType: '0',
        assignedWorkerLockTime: 0,
        orderShowTime: 0,
        option: {
            isDoubleClickPrevention: false,
            isAssignedWorkerCatchHidden: false,
            isAllocatedAfterCancel: false,
            isWorkerSupportAmount: false,
            isDeliveryStatus: false,
            // 3가지 경우의 수 있음
            isCustomerMessageService: 'Y',
        },
    },
    // 3가지 경우의 수 있음
    workerOneClickBaechaYn: 'Y',
    // formDTO에서 string type으로 변환 필요, Y | N
    laterUseYn: false,
    distanceProduct: 1.3,
});
export default createHubManagementFormData;
